/** Lokale Zeit für Trainerstunden-Sessions (Shared: Web, Mobile, Admin). */

export function toLocalDateInputValue(date) {
  if (!(date instanceof Date) || !Number.isFinite(date.getTime())) return "";
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

export function parseSessionStartMs(session) {
  const date = String(session?.date || "").slice(0, 10);
  if (!date) return NaN;
  const tm = String(session?.start_time || "00:00").trim();
  const m = tm.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/);
  const hh = m ? String(m[1]).padStart(2, "0") : "00";
  const mm = m ? m[2] : "00";
  const ss = m?.[3] ? m[3] : "00";
  return new Date(`${date}T${hh}:${mm}:${ss}`).getTime();
}

export function sessionEndMs(session) {
  const start = parseSessionStartMs(session);
  if (!Number.isFinite(start)) return NaN;
  const dur = Number(session?.duration_min) || 60;
  return start + dur * 60 * 1000;
}

export function isSessionTimeEnded(session, nowMs = Date.now()) {
  const end = sessionEndMs(session);
  return Number.isFinite(end) && end <= nowMs;
}

/** YYYY-MM-DD (Postgres `date` oder ISO-String). */
export function sessionDateOnly(raw) {
  const s = String(raw ?? "").trim();
  if (!s) return "";
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const d = new Date(s);
  if (!Number.isFinite(d.getTime())) return "";
  return toLocalDateInputValue(d);
}

/**
 * Liefert HH:MM:SS für ein lokales ISO-Datum.
 * Wichtig: `time` aus Supabase ist oft "17:00:00" — an "T...:00" anhängen würde "17:00:00:00" ergeben (ungültig).
 */
export function sessionTimeHms(raw) {
  const s = String(raw ?? "").trim();
  if (!s) return "00:00:00";
  const m = s.match(/^(\d{1,2}):(\d{2})(?::(\d{2}))?/);
  if (!m) return "00:00:00";
  const hh = String(m[1]).padStart(2, "0");
  const mm = m[2];
  const ss = m[3] != null ? m[3] : "00";
  return `${hh}:${mm}:${ss}`;
}
